import { useState } from 'react';
import ModalAvaliacao from '../ModalAvaliacao/ModalAvaliacao';
import './HistoricoUsuario.css';

const HistoricoUsuario = ({ appointments, user, onBack, onUpdateAppointment, onReschedule, onUpdateStatus }) => {
    const [selectedAppForRating, setSelectedAppForRating] = useState(null);

    const userAppointments = appointments.filter(app => {
        if (app.status === 'Sistema_Bloqueado') return false;

        const matchByUid = user.uid && app.clientId === user.uid;
        const matchByName = user.name && app.client && app.client.toLowerCase() === user.name.toLowerCase();
        const matchByPhone = user.whatsapp && app.whatsapp && app.whatsapp.replace(/\D/g, '') === user.whatsapp.replace(/\D/g, '');

        return matchByUid || matchByName || matchByPhone;
    }).sort((a, b) => new Date(b.date + 'T' + b.time) - new Date(a.date + 'T' + a.time));

    const getStatusClass = (status) => {
        switch (status) {
            case 'Agendado': return 'status-agendado';
            case 'Concluido': return 'status-concluido';
            case 'Cancelado': return 'status-cancelado';
            default: return '';
        }
    };

    const renderStars = (rating) => {
        return (
            <div className="summary-stars">
                {[...Array(5)].map((_, i) => (
                    <span key={i} className={i < rating ? "star-active" : "star-inactive"}>
                        ★
                    </span>
                ))}
            </div>
        );
    };

    return (
        <div className="user-history-container fade-in">
            <div className="history-header">
                <h2 className="history-title">Meus Agendamentos</h2>
                <p className="history-subtitle">Acompanhe seu histórico e próximos horários</p>
            </div>

            <div className="history-list">
                {userAppointments.length === 0 ? (
                    <div className="no-history">
                        <p>Você ainda não possui agendamentos.</p>
                        <button className="book-now-btn" onClick={onBack}>Agendar Agora</button>
                    </div>
                ) : (
                    userAppointments.map((app) => (
                        <div key={app.id} className="history-card">
                            <div className="card-top">
                                <span className={`status-badge ${getStatusClass(app.status)}`}>
                                    {app.status}
                                </span>
                                <span className="app-price">{app.price}</span>
                            </div>

                            <div className="card-main">
                                <h3 className="app-service">{app.service}</h3>
                                <div className="app-details">
                                    <div className="detail-item">
                                        <span className="detail-label">Barbeiro</span>
                                        <span className="detail-value">{app.barber}</span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="detail-label">Data</span>
                                        <span className="detail-value">{app.date.split('-').reverse().join('/')}</span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="detail-label">Horário</span>
                                        <span className="detail-value">{app.time}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="card-footer">
                                {app.status === 'Agendado' && (
                                    <div className="active-app-actions">
                                        <div className="app-meta-info">
                                            <p className="reminder-text">Compareça com 20 min de antecedência.</p>
                                        </div>
                                        <div className="action-buttons">
                                            <button
                                                className="reschedule-btn"
                                                onClick={() => onReschedule(app)}
                                            >
                                                Remarcar
                                            </button>
                                            <button
                                                className="cancel-btn"
                                                onClick={() => {
                                                    if (window.confirm("Deseja realmente cancelar este agendamento?")) {
                                                        onUpdateStatus(app.id, 'Cancelado');
                                                    }
                                                }}
                                            >
                                                Cancelar
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {app.status === 'Concluido' && (
                                    <div className="rating-section-history">
                                        {app.rating ? (
                                            <div className="already-rated">
                                                <span className="rating-label">Sua avaliação:</span>
                                                {renderStars(app.rating)}
                                            </div>
                                        ) : (
                                            <button
                                                className="evaluate-btn"
                                                onClick={() => setSelectedAppForRating(app)}
                                            >
                                                <span className="btn-star">★</span> Avaliar Experiência
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))
                )}
            </div>

            {selectedAppForRating && (
                <ModalAvaliacao
                    appointment={selectedAppForRating}
                    onClose={() => setSelectedAppForRating(null)}
                    onSubmit={onUpdateAppointment}
                />
            )}


        </div>
    );
};

export default HistoricoUsuario;
